<template>
    <div class="list">
        <NavBar></NavBar>
        <div v-if="!isShow">
            <van-col span='24' style="font-size:20px;font-weight:bold;text-align:center;padding-top:10px">{{title}}</van-col>
            <van-col span='24' style="font-size:12px;text-align:center;color:gray;margin:12px 0">{{createTime}}</van-col>
            <!-- <van-col span='24' style="color: rgb(59, 58, 58);padding:0px 15px 0 15px;font-size:12px;text-indent:2em">
                {{content}}
            </van-col> -->
            <div style="padding:0px 15px">
                <div v-html="content"></div>
            </div>
            <van-divider :style="{ color: 'gray', borderColor: 'gray', padding: '0 16px',fontSize:'12px',marginBottom:'70px'}">
                威海南海新区住宅维修资金宣
            </van-divider>
        </div>
        <div v-else>
            <van-empty image="error" description="加载失败..." />
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            id:'',
            title:'',
            createTime:'',
            content:'',
            isShow:false
        }
    },
    methods:{
        getContent(){
            let data={
                id:this.id
            }
            this.$postQuery('/weChatNotice/getNoticeDetailById', data).then((response) => {
                // console.log(response)
                if(response.code==200){
                    this.isShow = false
                    this.title = response.data.title
                    this.createTime = response.data.createTime
                    this.content = response.data.content
                    console.log(this.content)
                }else{
                    this.isShow = true
                }
                //
            })
        }
    },
    created(){
        this.id = this.$route.query.id;
        this.getContent()
    }
}
</script>

<style scoped>
.list {
    margin-top: 46px;
}
</style>